<template>
<div>
    <b-table striped responsive borderless :fields="header" :items="attributes">
        <template v-slot:cell(delete)="data">
            <b-form-checkbox v-model="data.item.checked"></b-form-checkbox>
        </template>
        <template v-slot:cell(key)="data">
            <template v-if="data.item.isDisabled">
                <b-form-input v-model="data.item.key" disabled></b-form-input>
            </template>
            <template v-else>
                <b-form-select v-model="data.item.key" :options="[
                            { value: 'properties', text: 'properties' }
                        ]">
                </b-form-select>
            </template>
        </template>
        <template v-slot:cell(name)="data">
            <b-form-input v-model="data.item.name" @input="changeItem($event, data.item, data.field.key)" :disabled="data.item.isDisabled"></b-form-input>
        </template>
        <template v-slot:cell(inputType)="data">
            <b-form-select v-model="data.item.inputType" :options="[
                            { value: 0, text: 'Text'},
                            { value: 1, text: 'List'},
                            { value: 2, text: 'Date' },
                            { value: 3, text: 'Location' },
                            { value: 31, text: 'Warehouse' },
                            { value: 32, text: 'Menu' },
                            { value: 4, text: 'DateTime' },
                            { value: 5, text: 'Checkbox' },
                            { value: 6, text: 'Checkbox And Date' },
                            { value: 7, text: 'URL' }
                        ]" @change="changeItem($event, data.item, data.field.key)" :disabled="data.item.isDisabled">
            </b-form-select>
        </template>
    </b-table>
    <div class="d-flex justify-content-between px-2">
        <ButtonAdd @click="attributeAddEmptyInput"></ButtonAdd>
        <div>
            <ButtonSave @click="updateOrCreateAttributes"></ButtonSave>
            <ButtonDelete @click="deleteAttributes"></ButtonDelete>
        </div>
    </div>
</div>
</template>

<script>
import ButtonEdit from "./buttons/ButtonEdit.vue";
import ButtonAdd from "./buttons/ButtonAdd.vue";
import ButtonDelete from "./buttons/ButtonDelete.vue";
import ButtonSave from "./buttons/ButtonSave.vue";
import * as queries from "../graphql/locus_queries"
import * as mutations from "../graphql/locus_mutations";
import global from "../Global.vue";
import AwsApi from '../Api';
import {
    API
} from "aws-amplify";

export default {
    components: {
        ButtonSave,
        ButtonDelete,
        ButtonAdd,
        ButtonEdit,
    },
    computed: {
        attributes() {
            return [...this.attributesApi, ...this.attributesAdd]
        }
    },
    data() {
        return {
            tenantId: "",
            attributesApi: [],
            attributesAdd: [],
            attr_errors: [],
            sourceTable: "Job",
            header: [{
                key: "delete",
                label: this.$t("select"),
            }, {
                key: "key",
                label: this.$t("attr_key"),
            }, {
                key: "name",
                label: this.$t("attr_name"),
            }, {
                key: "inputType",
                label: this.$t("attr_type"),
            }],
        }
    },
    mounted() {
        this.tenantId = sessionStorage.getItem(global.tenantId)
        this.fetchAttributes()
    },
    methods: {
        async fetchAttributes() {
            const response = await AwsApi.graphql({
                query: queries.queryItemDefines,
                variables: {
                    sourceTable: {
                        eq: this.sourceTable
                    },
                    tenantId: this.tenantId
                }
            }, this);
            this.attributesApi = [...this.attributeMapApiResponse(response.data.queryItemDefines.items)]
        },

        attributeMapApiResponse(response) {
            const resSort = response.sort(function (a, b) {
                return a.order - b.order
            });
            const properties = []
            resSort.forEach(item => {
                if (item.source.indexOf("Job.properties") !== -1) {
                    item["isDisabled"] = true
                    properties.push(item)
                }
            })

            const res = properties.map((element) => {
                if (element.source) {
                    const items = element.source.split('.')
                    if (items.length === 2) {
                        element["key"] = items[1]
                    } else if (items.length === 3) {
                        element["key"] = items[1]
                    }
                    element["checked"] = false
                    return element
                } else {
                    element["checked"] = false
                    return element
                }
            })

            return res
        },

        attributeAddEmptyInput() {
            const emptyAttribute = {
                key: null,
                name: null,
                inputType: 0,
                checked: false,
                toCreate: true
            };
            return this.attributesAdd = [...this.attributesAdd, emptyAttribute]
        },

        async deleteAttributes() {
            AwsApi.checkSession(() => {
                const deletePro = []

                const item_to_delete = this.attributesApi
                    .filter(attribute => attribute.checked && attribute.name !== "")
                    .map(attribute => attribute.source);
                this.attributesAdd = this.attributesAdd.filter(attribute => !attribute.checked)

                if (item_to_delete.length > 0) {
                    API.graphql({
                        query: queries.listMenuConfigs,
                        variables: {
                            tenantId: this.tenantId
                        }
                    }).then(response => {
                        item_to_delete.forEach((item, index) => {
                            var deleteAttribute = {
                                tenantId: this.tenantId,
                                source: item
                            }
                            deletePro.push(API.graphql({
                                query: mutations.deleteItemDefine,
                                variables: {
                                    input: deleteAttribute
                                }
                            }));

                            response.data.listMenuConfigs.items.forEach(menuItem => {
                                if (item === menuItem.source) {
                                    const deleteItem = {
                                        tenantId: this.tenantId,
                                        id: menuItem.id
                                    }
                                    deletePro.push(API.graphql({
                                        query: mutations.deleteMenuConfig,
                                        variables: {
                                            input: deleteItem
                                        }
                                    }));
                                }
                            })
                        })
                        Promise.all([...deletePro]).then(() => this.fetchAttributes())
                    })
                }

            }, this)
        },

        async updateOrCreateAttributes() {
            AwsApi.checkSession(async () => {
                const create = []
                const update = []
                const deletePro = []

                const item_to_create = [...this.attributesAdd, ...this.attributesApi.filter(attr => attr.toCreate && attr.name !== "")];
                const item_to_update = [...this.attributesApi.filter(attr => !attr.toCreate && attr.toUpdate)];

                var order = 0
                if (this.attributesApi.length != 0) {
                    order = this.attributesApi[this.attributesApi.length - 1].order + 1
                }

                item_to_create.forEach((item, index) => {
                    var createAttribute = {
                        group: this.tenantId,
                        tenantId: this.tenantId,
                        source: this.sourceTable + "." + item.key + "." + item.name,
                        name: item.name,
                        sourceTable: this.sourceTable,
                        inputType: item.inputType,
                        order: order + index
                    }
                    create.push(API.graphql({
                        query: mutations.createItemDefine,
                        variables: {
                            input: createAttribute
                        }
                    }));
                    this.attributesAdd = this.attributesAdd.filter(attr => item.id !== attr.id)
                })
                const response = await API.graphql({
                    query: queries.listMenuConfigs,
                    variables: {
                        tenantId: this.tenantId
                    }
                })
                item_to_update.forEach((item, index) => {
                    if (item.name !== "" || item.key === "itemCode") {
                        var updateAttribute = {
                            group: this.tenantId,
                            tenantId: this.tenantId,
                            source: this.sourceTable + "." + item.key + "." + item.name,
                            name: item.name,
                            sourceTable: this.sourceTable,
                            inputType: item.inputType
                        }
                        update.push(API.graphql({
                            query: mutations.updateItemDefine,
                            variables: {
                                input: updateAttribute
                            }
                        }));
                    } else {
                        var deleteAttribute = {
                            tenantId: this.tenantId,
                            source: item.source
                        }
                        deletePro.push(API.graphql({
                            query: mutations.deleteItemDefine,
                            variables: {
                                input: deleteAttribute
                            }
                        }));

                        response.data.listMenuConfigs.items.forEach(menuItem => {
                            if (item.source === menuItem.source) {
                                const deleteItem = {
                                    tenantId: this.tenantId,
                                    id: menuItem.id
                                }
                                deletePro.push(API.graphql({
                                    query: mutations.deleteMenuConfig,
                                    variables: {
                                        input: deleteItem
                                    }
                                }));
                            }
                        })
                    }
                })
                Promise.all([...create, ...update, ...deletePro]).then(() => this.fetchAttributes())
            }, this)
        },
        changeItem(value, cell, key) {
            cell.toUpdate = true
        },
    }
}
</script>
